import { createContext } from "react";
import { AuthContextProps, ManagerData } from "../data/types";

export const AuthContext = createContext<AuthContextProps>({
  isLoggedIn: false,
  userIsAdmin: false,
  userId: null,
  email: null,
  personalData: null,
  managerId: null,
  managerUserId: null,
  vendors: null,
  type: null,
  token: null,
  statusOk: false,
  status: null,
  signupPlan: null,
  activeModules: [],
  whitelabel: "",
  azumeFinanceData: {} as ManagerData["addons"]["finSoftware"],
  isSerranaCalcClient: false,
  azumeFinanceUsers: [],
  login: (
    userId,
    email,
    personalData,
    managerId,
    managerUserId,
    vendors,
    uToken,
    uType,
    uIsAdmin,
    uStatusOk,
    uStatus,
    usignupPlan,
    activeModules,
    whitelabel,
    azumeFinanceData,
    isSerranaCalcClient,
    expirationDate
  ) => {},
  logout: () => {},
});
